import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 text-center text-sm font-medium text-green-600"
}
const _hoisted_2 = { class: "grid gap-2" }
const _hoisted_3 = { class: "grid gap-2" }
const _hoisted_4 = { class: "flex items-center justify-between" }

import { Alert } from '@/components/ui/alert';
    import { Button } from '@/components/ui/button';
    import { Checkbox } from '@/components/ui/checkbox';
    import { computed } from 'vue';
    import { Head, useForm, usePage } from '@inertiajs/vue3';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import { MicrosoftLogo } from '@/components/icons';
    import { useI18n } from 'vue-i18n';
    import AuthBase from '@/layouts/AuthLayout.vue';
    import TextLink from '@/components/TextLink.vue';
    import type { SharedData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  props: {
    status: {},
    canResetPassword: { type: Boolean }
  },
  setup(__props: any) {

    

    const page = usePage<SharedData>();
    const noCompany = computed(() => page.props.errors?.no_company);

    const { t } = useI18n();

    const form = useForm({
        email: '',
        password: '',
        remember: false,
    });

    const submit = () => {
        form.post(route('login'), {
            onFinish: () => form.reset('password'),
        });
    };

    const loginWithMicrosoft = () => {
        window.location.href = '/admin/login';
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthBase, null, {
    default: _withCtx(() => [
      _createVNode(_unref(Head), { title: "Log in" }),
      (_ctx.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.status), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (submit()), ["prevent"])),
        class: "flex flex-col gap-4"
      }, [
        (_unref(form).errors.email)
          ? (_openBlock(), _createBlock(_unref(Alert), {
              key: 0,
              variant: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('auth.login_error')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (noCompany.value)
          ? (_openBlock(), _createBlock(_unref(Alert), {
              key: 1,
              variant: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('auth.no_company')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Input), {
            id: "email",
            type: "email",
            required: "",
            autofocus: "",
            tabindex: 1,
            autocomplete: "email",
            modelValue: _unref(form).email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).email) = $event)),
            placeholder: _unref(t)('auth.email_placeholder'),
            class: "placeholder:text-foreground/80"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Input), {
            id: "password",
            type: "password",
            required: "",
            tabindex: 2,
            autocomplete: "current-password",
            modelValue: _unref(form).password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
            placeholder: _unref(t)('auth.password_placeholder'),
            class: "placeholder:text-foreground/80"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_unref(Button), {
          type: "submit",
          width: "full",
          tabindex: 4,
          disabled: _unref(form).processing,
          loading: _unref(form).processing
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('auth.login_txt')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Label), {
            for: "remember",
            class: "flex items-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Checkbox), {
                id: "remember",
                modelValue: _unref(form).remember,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).remember) = $event)),
                tabindex: 3
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('auth.remember_me')), 1)
            ]),
            _: 1
          }),
          (_ctx.canResetPassword)
            ? (_openBlock(), _createBlock(TextLink, {
                key: 0,
                href: _ctx.route('password.request'),
                class: "text-xs",
                tabindex: 5
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('auth.forgot_password')), 1)
                ]),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true)
        ])
      ], 32),
      _createVNode(_unref(Button), {
        onClick: loginWithMicrosoft,
        variant: "outline",
        width: "full",
        tabindex: 4,
        disabled: _unref(form).processing
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MicrosoftLogo)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('auth.login_with_microsoft')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})